import React from 'react';
import PropTypes from 'prop-types';

import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';

// =============================================================================
// BLOCK TMSTH.1 — Outstanding Orders TMS Table Header Component
// Displays column headers for parent-level order information with collapse control
// =============================================================================
function OutstandingOrdersTMSHeader({ sortBy, sortDir, onSort }) {
  // BLOCK TMSTH.1.1 — Define column headers for parent rows
  const headers = [
    { label: '', key: 'expand', width: '40px', sortable: false }, // Expand/collapse button
    { label: 'Sales Order #', key: 'SalesOrderNo', sortable: true },
    { label: 'Order Date', key: 'OrderDate', sortable: true },
    { label: 'Time Created', key: 'TimeCreated', sortable: true },
    { label: 'Created By', key: 'RMANo', sortable: true },
    { label: 'Facility', key: 'FacilityName', sortable: true },
    { label: 'Ship To', key: 'ShipToName', sortable: true },
    { label: 'Customer PO', key: 'CustomerPONo', sortable: true },
    { label: 'Ship Via', key: 'ShipVia', sortable: true },
    { label: 'Ship Status', key: 'ShipStatus', sortable: true },
  ];

  // BLOCK TMSTH.1.2 — Render table header row
  return (
    <TableHead>
      <TableRow
        sx={{
          backgroundColor: 'action.hover',
          fontWeight: 'bold',
          '& .MuiTableCell-root': {
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          },
        }}
      >
        {headers.map((header) => (
          <TableCell
            key={header.key}
            sx={{
              fontWeight: 'bold',
              color: 'text.primary',
              whiteSpace: 'nowrap',
              padding: '12px 8px',
              width: header.width,
            }}
            data-cy={`header-${header.key}`}
          >
            {/* BLOCK TMSTH.1.3 — TableSortLabel prepared for future sorting functionality */}
            <TableSortLabel
              disabled={!header.sortable}
              active={header.sortable && sortBy === header.key}
              direction={header.sortable && sortBy === header.key ? sortDir : 'asc'}
              onClick={header.sortable ? () => onSort(header.key) : undefined}
              sx={{
                color: 'text.primary',
                '&.Mui-disabled': {
                  color: 'text.primary',
                  opacity: 0.92,
                },
              }}
            >
              {header.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

OutstandingOrdersTMSHeader.propTypes = {
  sortBy: PropTypes.string.isRequired,
  sortDir: PropTypes.oneOf(['asc', 'desc']).isRequired,
  onSort: PropTypes.func.isRequired,
};

export default OutstandingOrdersTMSHeader;
